<template>
    <div id="container" type="vdpp">
        <div class="page page-sell" v-ga:request="{pageType:'vsell', state: {}}" v-ga:page="{pageType:'vsell', glb: glb, state: {}}">
            <mvtHeader />
            <section class="inline welcome large bg-brand">
                <div class="grid gap-3 fixed fixed-max-sm middle xs-grid-cols-1 center">
                    <h1 class="f0 text-bold">Get a Cash Offer on Your Home</h1>
                    <div>Cash offers can enable you to enjoy the benefits of a fast, stress-free home sale. <br> By entering your home address below, we’ll help you determine if a cash offer is right for you.</div>
                    <mvtInputGeo class="large w-100" ref="addressInput" v-model="geoInfo" :placeholder="glb.isPhone ? 'Enter Address' : 'Enter Your Home Address'"  :options="{types:['address']}">Get Started</mvtInputGeo>
                </div>
            </section>
            <section class="inline bg-default large">
                <div class="grid fixed fixed-max-sm gap-3 xs-grid-cols-1 center text-center">
                    <h2 class="f0 text-bold">How <span class="text-brand">Cash Offer</span> Works</h2>
                    <div>Requesting a cash offer is a simple process intended to help you reach your goals faster.</div>
                    <button type="button" class="btn primary regular" @click="sendCashOffer">Request Cash Offer</button>
                </div>
            </section>
            <section class="inline bg-default large">
                <div class="grid fixed fixed-max-sm gap-3 xs-grid-cols-1 sm-grid-cols-3 text-center">
                    <div class="inline bg-default outline corner flex vertical large top">
                        <img class="w-100" alt="Web Home" :src="`${glb.cdnUrl}vimages/web-home.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1 center">
                            <h3 class="text-bold f4">Tell Us About Your Home</h3>
                            <div>Request an offer, providing details about your home and your selling goals.</div>
                        </div>
                    </div>
                    <div class="inline bg-default outline corner flex vertical large top">
                        <img class="w-100" alt="Web Offer" :src="`${glb.cdnUrl}vimages/web-offer.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1 center">
                            <h3 class="text-bold f4">Review Your Offer</h3>
                            <div>Review the available cash offers with top local listing agents from our network, ensuring it meets your needs and expectations.</div>
                        </div>
                    </div>
                    <div class="inline bg-default outline corner flex vertical large top">
                        <img class="w-100" alt="Web Homesold" :src="`${glb.cdnUrl}vimages/web-homesold.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1 center">
                            <h3 class="text-bold f4">Close and Move</h3>
                            <div>Select the date you’d like to close. Enjoy the benefits of a fast, stress-free home sale.</div>
                        </div>
                    </div>
                </div>
            </section>
            <sellContent></sellContent>
            <mvtFooter />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-sellfast.js"></script>